import { render, staticRenderFns } from "./syns-add.vue?vue&type=template&id=d3f6c9ec"
import script from "./syns-add.vue?vue&type=script&lang=js"
export * from "./syns-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports